<template>
  <blockquote :class="`blockquote blockquote--${alignClass}`">
    <div class="blockquote__quote" v-html="quote" />
    <div class="blockquote__source" v-html="source" />
  </blockquote>
</template>

<script>
import PrismicDOM from 'prismic-dom'

export default {
  name: 'content-blockquote',
  props: ['content'],
  computed: {
    alignClass () {
      return this.content.primary.align ? this.toCssName(this.content.primary.align) : 'none'
    },
    quote () {
      return this.content.primary.quote ? PrismicDOM.RichText.asHtml(this.content.primary.quote) : null
    },
    source () {
      return this.content.primary.source ? PrismicDOM.RichText.asHtml(this.content.primary.source) : null
    }
  },
  methods: {
    toCssName (str) {
      return str.replace(/\s+/g, '-').toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
  .blockquote {
    border-top: 1px solid;
    border-bottom: 1px solid;
    display: inline-block;
    font-family: $font-heading;
    font-weight: $font-heading-weight;
    margin: 0 auto 1rem;
    padding: 4rem 1rem;

    @media (min-width: $breakpoint-md) {
      border-top: none;
      border-bottom: none;
      max-width: 80vw;
    }
  }

  .blockquote--right,
  .blockquote--left {
    @media (min-width: $breakpoint-md) {
       width: 50%;
       max-width: 420px;
    }
  }

  .blockquote--center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    width: auto;
    padding: 5rem 1rem;

    @media (min-width: $breakpoint-md) {
      max-width: 1024px;
      text-align: center;
      padding: 5rem 0;
      width: 80%;
    }
  }

  .blockquote--right {
    @media (min-width: $breakpoint-md) {
      border-left: 1px solid;
      float: right;
      margin-left: 3rem;
      margin-right: 0;
      padding-left: 2rem;
    }

    @media (min-width: $breakpoint-lg) {
      margin-right: 18%;
    }
  }

  .blockquote--left {
    @media (min-width: $breakpoint-md) {
      border-right: 1px solid;
      float: left;
      margin-right: 3rem;
      margin-left: 0;
      padding-right: 2rem;
    }

    @media (min-width: $breakpoint-lg) {
      margin-left: 18%;
    }
  }

  .blockquote__quote {
    font-size: 1.8rem;
    line-height: 2.6rem;
    position: relative;

    @media (min-width: $breakpoint-lg) {
      font-size: 2.3rem;
      line-height: 3rem;
    }

    &:before {
      content: "";
      background-repeat: no-repeat;
      height: 60px;
      position: absolute;
      top: -4rem;
      left: 0;
      width: 80px;
    }

    &:after {
      content: "";
      background-repeat: no-repeat;
      bottom: -5.5rem;
      height: 60px;
      left: 0;
      position: absolute;
      width: 80px;
    }
  }

  .blockquote--center .blockquote__quote::before,
  .blockquote--center .blockquote__quote::after {
    @media (min-width: $breakpoint-md) {
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .blockquote__source {
    font-style: italic;
    text-align: right;
  }

  .leadership .blockquote__quote::before {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='78' height='41' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23F49746' fill-rule='evenodd'%3E%3Cpath d='M40.772 0L0 41h29.623l7.77-7.69L24.89 20.49 43 2.244zM73.51 0L33 41h45L57.73 20.47 75.725 2.244z'/%3E%3C/g%3E%3C/svg%3E");
  }

  .leadership .blockquote__quote::after {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='77' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23F6983E' fill-rule='evenodd'%3E%3Cpath d='M47.629 0l-7.671 7.453L52.3 19.883 34.425 37.571l2.198 2.176L76.86 0zM0 0l20.114 19.903L2.257 37.57l2.199 2.176L44.655 0z'/%3E%3C/g%3E%3C/svg%3E");
  }

  .legal-market .blockquote__quote::before {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='78' height='41' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%236689C6' fill-rule='evenodd'%3E%3Cpath d='M40.772 0L0 41h29.623l7.77-7.69L24.89 20.49 43 2.244zM73.51 0L33 41h45L57.73 20.47 75.725 2.244z'/%3E%3C/g%3E%3C/svg%3E");
  }

  .legal-market .blockquote__quote::after {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='77' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%236689C6' fill-rule='evenodd'%3E%3Cpath d='M47.629 0l-7.671 7.453L52.3 19.883 34.425 37.571l2.198 2.176L76.86 0zM0 0l20.114 19.903L2.257 37.57l2.199 2.176L44.655 0z'/%3E%3C/g%3E%3C/svg%3E");
  }

  .legal-tech .blockquote__quote::before {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='78' height='41' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%231D478D' fill-rule='evenodd'%3E%3Cpath d='M40.772 0L0 41h29.623l7.77-7.69L24.89 20.49 43 2.244zM73.51 0L33 41h45L57.73 20.47 75.725 2.244z'/%3E%3C/g%3E%3C/svg%3E");
  }

  .legal-tech .blockquote__quote::after {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='77' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%231D478D' fill-rule='evenodd'%3E%3Cpath d='M47.629 0l-7.671 7.453L52.3 19.883 34.425 37.571l2.198 2.176L76.86 0zM0 0l20.114 19.903L2.257 37.57l2.199 2.176L44.655 0z'/%3E%3C/g%3E%3C/svg%3E");
  }

  .management .blockquote__quote::before {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='78' height='41' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%2308AFA4' fill-rule='evenodd'%3E%3Cpath d='M40.772 0L0 41h29.623l7.77-7.69L24.89 20.49 43 2.244zM73.51 0L33 41h45L57.73 20.47 75.725 2.244z'/%3E%3C/g%3E%3C/svg%3E");
  }

  .management .blockquote__quote::after {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='77' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%2308AFA4' fill-rule='evenodd'%3E%3Cpath d='M47.629 0l-7.671 7.453L52.3 19.883 34.425 37.571l2.198 2.176L76.86 0zM0 0l20.114 19.903L2.257 37.57l2.199 2.176L44.655 0z'/%3E%3C/g%3E%3C/svg%3E");
  }


</style>



// WEBPACK FOOTER //
// Blockquote.vue?5bfb0981